import * as yup from 'yup';

import { UpdateConf as UsersNauticaConf } from '../../users_nautica/conf/Update.conf';
import { UpdateConf as UsersCrewConf } from '../../users_crew/conf/Update.conf';
import { CommonConf } from '../conf/common/CommonConf.conf';
import _ from 'lodash';

export const UpdateConf = {
	Nautica: {
		schema: yup.object({
			...UsersNauticaConf.schema,
			...CommonConf.schema,
		}),
		defaultValues: {
			...UsersNauticaConf.defaultValues,
			...CommonConf.defaultValues,
		},
		fields: _.concat(CommonConf.fields, UsersNauticaConf.fields),
	},
	Crew: {
		schema: yup.object({
			...UsersCrewConf.schema,
			...CommonConf.schema,
		}),
		defaultValues: {
			...UsersCrewConf.defaultValues,
			...CommonConf.defaultValues,
		},
		fields: _.concat(CommonConf.fields, UsersCrewConf.fields),
	},
};
